import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../layouts/Layout";
import Hero from "../components/camps/Hero";
import FeatureBar from "../components/camps/FeatureBar";
import CTASection from "../components/CTASection";
import CampsCourses from "../components/camps/CampsCourses";
import AdvantagesSection from "../components/camps/AdvantagesSection";

const SummerCamps = () => {
  const navigate = useNavigate();

  const handleClaimSpot = () => {
    navigate("/camps-registration");
  };

  return (
    <Layout>
      <Hero bg="bg-[#E59600]" title="Summer Camps" />
      <FeatureBar />
      <CampsCourses />
      <div className="bg-[#f5f5f5] pt-[75px] pb-20 ">
        <CTASection
          title="Turn Your Summer Into a Code Adventure"
          textSize="text-5xl"
          subText="Join our camp and explore coding, creativity, and fun projects!"
          btnText="Claim your Spot Now"
          btnSize="px-[54.5px]"
          isAddToCartVisible={false}
          onBuyNowClick={handleClaimSpot}
        />
      </div>
      <AdvantagesSection/>
    </Layout>
  );
};

export default SummerCamps;
